import React, { useEffect, useState } from "react";
import {
  Pagination,
  Stack,
  Button,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  IconButton,
  Typography,
  Drawer,
  ButtonGroup,
  Grid,
} from "@mui/material";
import Nodata from "../../Assets/images/svg/Data-unavailable.svg";
import { FunnelSimple } from "@phosphor-icons/react";
import { MdCall } from "react-icons/md";
import { MdOutlineFileUpload } from "react-icons/md";
import { toast } from "react-toastify";
import "../SupervisorContact/supervisor.css";
import axios from "axios";
import {
  BaseUrl,
  excelDownloadUrl,
  VoiceDomainName,
  VoiceDomainNamePure,
} from "../../Container/BaseUrl/BaseUrl";
import { MdDriveFolderUpload } from "react-icons/md";
import { PhoneOutgoing, Upload } from "@phosphor-icons/react";
import { connect } from "react-redux";
import {
  setDialedNumberInc,
  getAvailableAgentList,
} from "../../Redux/Actions/actions";
import { TiWarningOutline } from "react-icons/ti";
import { toaststyle } from "../../Utils/toaststyle";
import { Hourglass } from "react-loader-spinner";
import {
  StyledPaper,
  StyledTableContainer,
  StyledTable,
  StyledTableHead,
  StyledTableBody,
  StyledTableRow,
  StyledTableCell,
  StyledTableCell2,
} from "../../CustomComponent/TableCompoent";

const mapStateToProps = (state) => {
  return {
    skillset: state.data.skillset,
    showingStatusVoice: state.contactListData.showingStatusVoice,
    DropDownAgentList: state.contactListData.DropDownAgentList,
  };
};

const Campaign = (props) => {
  const loggedInAgent = JSON.parse(localStorage.getItem("tokenAgent"));

  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];

  const isToDateValid = () => {
    return new Date(todate) >= new Date(fromdate);
  };

  const [fromdate, setFromdate] = useState("");
  const [todate, setTodate] = useState("");
  const [getTransferDate, setgetTransferDate] = useState();
  const [showfilter, setshowfilter] = useState(false);
  const [status, setstatus] = useState("");
  const [UploadDialogBox, setUploadDialogBox] = useState(false);
  const [UploadButton, setUploadButton] = useState(true);
  const [SupervisorCampaignList, setSupervisorCampaignList] = useState([]);
  const [agentCampaignList, setAgentCampaignList] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(0);
  const [selectedAgents, setSelectedAgents] = useState([]);
  const [spinner, setspinner] = useState(false);
  const [loader, setloader] = useState(false);
  const [selectedfile, setSelectedfile] = useState(false);
  const [openDialog, setopenDialog] = useState(false);
  const [sourceAgents, setsourceAgents] = useState("");
  const [DestinationAgents, setDestinationAgents] = useState("");
  const [campaignCallList, setcampaignCallList] = useState([]);
  const [selectedCalls, setselectedCalls] = useState();
  const [totalcalls, settotalcalls] = useState(0);
  const [opensuccessmodal, setOpensuccessmodal] = useState(false);
  const [opensuccessmodalresponse, setOpensuccessmodalresponse] = useState("");

  const handleChangeCount = (event) => {
    setselectedCalls(event.target.value);
  };
  const handleCloseDialogBox = () => {
    setopenDialog(false);
  };

  const handleCloseDialogBoxresponse = () => {
    setOpensuccessmodal(false);
  };
  const handleClose = () => {
    setUploadDialogBox(false);
  };
  const hiddenFileInput = React.useRef(null);
  const handleClosePreview = () => {
    if (hiddenFileInput.current) {
      hiddenFileInput.current.value = "";
    }
  };

  const handleConfirmUploadPreview = (event) => {
    const dataFile = event.target.files[0];
    setSelectedfile(dataFile);
    if (selectedAgents.length > 0 && dataFile) {
      setUploadButton(false);
    } else {
      setUploadButton(true);
    }
  };

  const SaleshandleChangeFile = async (file) => {
    if (file) {
      let agent = JSON.stringify(selectedAgents);
      const dataArray = new FormData();
      dataArray.append("file", file);
      dataArray.append("agentList", agent);
      setspinner(true);

      await axios
        .post(BaseUrl + "/users/createExcelSheetCampaign", dataArray, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "multipart/form-data",
            tenantId: localStorage.getItem("TenantId"),
          },
        })
        .then((res) => {
          setOpensuccessmodal(true);
          setOpensuccessmodalresponse(res.data);
          setTimeout(() => {
            setspinner(false);
          }, 2000);
          setSelectedfile(null);
          SupervisorListCampaign();
          handleClose();
          setSelectedAgents([]);
        })
        .catch((err) => {
          console.log("err", err);
          setOpensuccessmodal(true);
          setOpensuccessmodalresponse(res.data);
          toast.error("sales excel not uploaded", toaststyle);
          setspinner(false);
          setSelectedfile(null);
          setSelectedAgents(null);
          setSelectedAgents([]);
        });
    }
  };

  const handleChange = (event, value) => {
    setPage(value);
    if (loggedInAgent.role === "Supervisor") {
      SupervisorListCampaign(value);
    } else {
      AgentListCampaign(value);
    }
  };

  const handleChangeAgent = (event) => {
    setSelectedAgents(event.target.value);
    if (selectedfile && event.target.value.length > 0) {
      setUploadButton(false);
    } else {
      setUploadButton(true);
    }
  };

  const UploadhandleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const AgentListCampaign = async (value) => {
    if (!value) {
      setloader(true);
    }
    let data = {
      from_date: fromdate,
      to_date: todate,
      agent_id: loggedInAgent.agent_id,
      offset: value != null ? (value === 1 ? 0 : (value - 1) * 10) : 0,
      limit: 10,
      type: status,
    };
    await axios
      .post(BaseUrl + "/contact/listcampaign", data, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        if (res.data.status == true) {
          setAgentCampaignList(res.data.data);
          setcampaignCallList(res.data.data);
          settotalcalls(res.data.count);
          setPagination(res.data.count);
          setloader(false);
        } else {
          toast.warn("No Data Found", toaststyle);
          setAgentCampaignList([]);
          setPagination(0);
          settotalcalls(0);
          setcampaignCallList([]);
          setloader(false);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setAgentCampaignList([]);
        setPagination(0);
        setloader(false);
      });
  };
  const SupervisorListCampaign = async (value) => {
    if (!value) {
      setloader(true);
    }
    let body = {
      from_date: fromdate,
      to_date: todate,
      agent_id: loggedInAgent.agent_id,
      offset: value != null ? (value === 1 ? 0 : (value - 1) * 10) : 0,
      limit: 10,
      type: status,
    };
    await axios
      .post(BaseUrl + "/contact/listcampaignsupervisor", body, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        setloader(true);
        if (res.data.status == true) {
          setSupervisorCampaignList(res.data.data);
          setcampaignCallList(res.data.data);
          setPagination(res.data.count);
          settotalcalls(res.data.count);
          setloader(false);
        } else {
          setSupervisorCampaignList([]);
          setcampaignCallList([]);
          settotalcalls(0);
          setPagination(0);
          setloader(false);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setSupervisorCampaignList([]);
        setPagination(0);
        setloader(false);
      });
  };

  const makeCall = (calledNo, id) => {
    let number = `90${calledNo}`;
    if (props.showingStatusVoice == "Ready") {
      let agentLoginTerminalId = localStorage.getItem("agentLoginTerminalId");
      let avcurlid = localStorage.getItem("AvcUrl");
      props.setDialedNumberInc(number);
      localStorage.setItem("callDirectionType", "CM_Outbound");
      localStorage.setItem("dailedNumber", number);
      localStorage.setItem("ClickToCall", "true");
      localStorage.setItem("clickToCallCallerID", id);
      axios
        .post(
          avcurlid +
            `/voice/terminal/${agentLoginTerminalId}/createContact/sip:${agentLoginTerminalId}@${
              localStorage.getItem("TenantId") ==
              "788205e1-6116-4c09-904a-5b641d09de0f"
                ? VoiceDomainNamePure
                : VoiceDomainName
            }/sip:${number}@${
              localStorage.getItem("TenantId") ==
              "788205e1-6116-4c09-904a-5b641d09de0f"
                ? VoiceDomainNamePure
                : VoiceDomainName
            }`,
          {},
          {
            headers: {
              ssoToken: localStorage.getItem("ssoToken"),
            },
          }
        )
        .then((res) => {
          if (res.data.status == "OK") {
            localStorage.setItem("DCC_CALL", "true");
          } else {
            toast.warn(res.data.status, toaststyle);
          }
        })
        .catch((err) => {
          if (err.code == "ERR_BAD_REQUEST") {
            toast.error("Please change status to Ready", toaststyle);
          }
        });
    } else {
      toast.error("Please change status to Ready", toaststyle);
    }
  };

  const transfer = async () => {
    await axios
      .post(
        BaseUrl + "/contact/updatecampaignDetailsagent",
        {
          source_id: sourceAgents,
          destination_id: DestinationAgents,
          count: selectedCalls,
          date: getTransferDate,
          type: "Campaign",
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setopenDialog(false);
          SupervisorListCampaign();
          toast.success(res.data.message, toaststyle);
        } else {
          setopenDialog(false);
          SupervisorListCampaign();
          toast.warn(res.data.message, toaststyle);
        }
      })
      .catch((err) => {
        setShow(true);
      });
  };
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (loggedInAgent.role === "Supervisor") {
        SupervisorListCampaign("noSpinner");
        setPage(1);
      } else {
        AgentListCampaign("noSpinner");
        setPage(1);
      }
    }, 60000);
    return () => clearInterval(intervalId);
  }, [page]);

  useEffect(() => {
    if (loggedInAgent.role === "Supervisor") {
      SupervisorListCampaign();
    } else {
      AgentListCampaign();
    }
  }, []);

  return (
    // campaign start here
    <StyledPaper>
      {/* card start here */}
      <div className="card Report-card w-100 border-0">
        {/* card-header  */}
        <div
          className="card-header border-0 d-flex align-items-center justify-content-between px-2"
          sx={{ fontWeight: 600, color: "#1473e6" }}
        >
          <div
            className="fw-bold fs-16"
            style={{
              textShadow: "1px 0px 0px #c2c2c27d",
              color: "#0b3363",
            }}
          >
            Campaign
          </div>
          <div>
            {loggedInAgent.role == "Supervisor" ? (
              <ButtonGroup
                variant="contained"
                aria-label="button group"
                disableElevation
                size="small"
                sx={{
                  textTransform: "capitalize",
                }}
              >
                {/* Transfer Call btn  */}
                <Button
                  sx={{
                    textTransform: "capitalize",
                  }}
                  onClick={() => {
                    setopenDialog(true);
                    props.getAvailableAgentList();
                  }}
                >
                  <MdCall className="me-2" />
                  Transfer Call
                </Button>
                {/* upload btn  */}
                <Button
                  sx={{
                    textTransform: "capitalize",
                  }}
                  onClick={() => {
                    props.getAvailableAgentList();
                    setUploadDialogBox(true);
                  }}
                >
                  <MdOutlineFileUpload className="me-2" />
                  Upload
                </Button>
                {/* Filter btn  */}
                <Button
                  sx={{
                    textTransform: "capitalize",
                  }}
                  onClick={() => {
                    setshowfilter(true);
                  }}
                >
                  <FunnelSimple className="me-2" />
                  Filter
                </Button>
              </ButtonGroup>
            ) : (
              <ButtonGroup
                variant="contained"
                aria-label="button group"
                disableElevation
                size="small"
                sx={{
                  textTransform: "capitalize",
                }}
              >
                {/* Filter btn  */}
                <Button
                  sx={{
                    textTransform: "capitalize",
                  }}
                  onClick={() => {
                    setshowfilter(true);
                  }}
                >
                  <FunnelSimple className="me-2" />
                  Filter
                </Button>
              </ButtonGroup>
            )}
          </div>
        </div>
        {/* card-body */}
        <div
          className="card-body p-1 vh-71 box-inset"
          sx={{
            justifyContent: "center",
            display: "flex",
            height: "calc(100% - 40px)",
            display: "flex",
            flexDirection: "column",
            gap: "10",
          }}
        >
          <Box>
            <StyledTableContainer sx={{ height: "26rem !important" }}>
              <StyledTable stickyHeader aria-label="sticky table" size="small">
                {loggedInAgent.role == "Supervisor" ? (
                  <>
                    <StyledTableHead>
                      <StyledTableRow>
                        {[
                          "Agent",
                          "Customer Name",
                          "Phone Number",
                          "Call Status",
                          "Campaign Name",
                          "CustomerID",
                          "ContactID",
                          "Retry Count",
                          "Retry Status",
                        ].map((headers) => (
                          <StyledTableCell style={{ minWidth: "130px" }}>
                            {headers}
                          </StyledTableCell>
                        ))}
                      </StyledTableRow>
                    </StyledTableHead>
                    <StyledTableBody>
                      {loader ? (
                        <Stack
                          sx={{ position: "absolute", top: "50%", left: "50%" }}
                        >
                          <Hourglass
                            visible={true}
                            height="30"
                            width="30"
                            ariaLabel="hourglass-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                            colors={["#2268a0", "#72a1ed"]}
                          />
                        </Stack>
                      ) : SupervisorCampaignList.length > 0 ? (
                        SupervisorCampaignList.map((item) => {
                          return (
                            <StyledTableRow hover role="checkbox" tabIndex={-1}>
                              <StyledTableCell2>
                                {item.agent_id.username}
                              </StyledTableCell2>
                              <StyledTableCell2>
                                {item.FirstName}
                              </StyledTableCell2>
                              <StyledTableCell2>
                                {item.PhoneNumber}
                              </StyledTableCell2>
                              <StyledTableCell2>
                                {item.CallStatus}
                              </StyledTableCell2>
                              <StyledTableCell2>
                                {item.CampaignName}
                              </StyledTableCell2>
                              <StyledTableCell2>
                                {item.CustomerID}
                              </StyledTableCell2>
                              <StyledTableCell2>
                                {item.ContactID}
                              </StyledTableCell2>

                              <StyledTableCell2>
                                {item.callcount ? item.callcount : "--"}
                              </StyledTableCell2>
                              <StyledTableCell2>
                                {item.callstatus ? item.callstatus : "NA"}
                              </StyledTableCell2>
                            </StyledTableRow>
                          );
                        })
                      ) : (
                        // Data unavailable start
                        <Stack
                          sx={{
                            position: "absolute",
                            width: "100%",
                            height: "calc(100vh - 14rem)",
                          }}
                          justifyContent="center"
                          alignContent="center"
                        >
                          <Stack
                            className="text-muted"
                            direction="column"
                            justifyContent="center"
                            alignContent="center"
                          >
                            <span className="mx-auto">
                              <img
                                src={Nodata}
                                alt="pic"
                                style={{ width: "11rem", userSelect: "none" }}
                              />
                            </span>
                            <span className="mx-auto">
                              <h6
                                className="text-muted mt-3"
                                style={{ fontSize: "13px" }}
                              >
                                Data unavailable
                              </h6>
                            </span>
                          </Stack>
                        </Stack>
                        // Data unavailable end
                      )}
                    </StyledTableBody>
                  </>
                ) : (
                  <>
                    <StyledTableHead>
                      <StyledTableRow>
                        {[
                          "Customer Name",
                          "Phone Number",
                          "Call Status",
                          "Campaign Name",
                          "CustomerID",
                          "ContactID",
                          "Retry Count",
                          "Retry Status",
                          "Action",
                        ].map((headers) => (
                          <StyledTableCell style={{ minWidth: "150px" }}>
                            {headers}
                          </StyledTableCell>
                        ))}
                      </StyledTableRow>
                    </StyledTableHead>
                    <StyledTableBody>
                      {loader ? (
                        <Stack
                          sx={{ position: "absolute", top: "50%", left: "50%" }}
                        >
                          <Hourglass
                            visible={true}
                            height="30"
                            width="30"
                            ariaLabel="hourglass-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                            colors={["#2268a0", "#72a1ed"]}
                          />
                        </Stack>
                      ) : agentCampaignList.length > 0 ? (
                        agentCampaignList.map((item) => {
                          return (
                            <StyledTableRow hover role="checkbox" tabIndex={-1}>
                              <StyledTableCell2>
                                {item.FirstName}
                              </StyledTableCell2>
                              <StyledTableCell2>
                                {item.PhoneNumber}
                              </StyledTableCell2>
                              <StyledTableCell2>
                                {item.CallStatus}
                              </StyledTableCell2>
                              <StyledTableCell2>
                                {item.CampaignName}
                              </StyledTableCell2>
                              <StyledTableCell2>
                                {item.CustomerID}
                              </StyledTableCell2>
                              <StyledTableCell2>
                                {item.ContactID}
                              </StyledTableCell2>
                              <StyledTableCell2>
                                {item.callcount ? item.callcount : "--"}
                              </StyledTableCell2>
                              <StyledTableCell2>
                                {item.callstatus ? item.callstatus : "NA"}
                              </StyledTableCell2>
                              <StyledTableCell2>
                                <IconButton
                                  onClick={() => {
                                    localStorage.setItem(
                                      "CampaignCallClicktoCall",
                                      item.id
                                    );
                                    localStorage.setItem(
                                      "CampaignCallClicktoCallName",
                                      item.FirstName
                                    );
                                    makeCall(item.PhoneNumber, item.id);
                                  }}
                                >
                                  <PhoneOutgoing size={18} weight="bold" />
                                </IconButton>
                              </StyledTableCell2>
                            </StyledTableRow>
                          );
                        })
                      ) : (
                        // Data unavailable start
                        <Stack
                          sx={{
                            position: "absolute",
                            width: "100%",
                            height: "calc(100vh - 14rem)",
                          }}
                          justifyContent="center"
                          alignContent="center"
                        >
                          <Stack
                            className="text-muted"
                            direction="column"
                            justifyContent="center"
                            alignContent="center"
                          >
                            <span className="mx-auto">
                              <img
                                src={Nodata}
                                alt="pic"
                                style={{ width: "11rem", userSelect: "none" }}
                              />
                            </span>
                            <span className="mx-auto">
                              <h6
                                className="text-muted mt-3"
                                style={{ fontSize: "13px" }}
                              >
                                Data unavailable
                              </h6>
                            </span>
                          </Stack>
                        </Stack>
                        // Data unavailable end
                      )}
                    </StyledTableBody>
                  </>
                )}
              </StyledTable>
            </StyledTableContainer>
          </Box>
        </div>
        {/* card-footer */}
        <div className="card-footer border-0">
          <Box>
            <Stack
              sx={{ width: "100%", height: "100%" }}
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              {/* Pagination content  */}
              <Typography variant="caption" sx={{ fontSize: "12px" }}>
                Showing {Math.min((page - 1) * 10 + 1, pagination)} to{" "}
                {Math.min(page * 10, pagination)} of {pagination} entries
              </Typography>
              {/* Pagination  */}
              <Pagination
                count={Math.ceil(pagination / 10)}
                page={page}
                shape="rounded"
                color="primary"
                size="small"
                style={{ float: "right" }}
                onChange={handleChange}
              />
            </Stack>
          </Box>
        </div>
      </div>
      {/* card end here */}

      {/* Filters Drawer Start  */}
      <Drawer
        anchor="right"
        open={showfilter}
        onClose={() => {
          setshowfilter(false);
        }}
      >
        <Box style={{ width: "20rem" }}>
          {/* Drawer head start */}
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            className="p-3 shadowDrawer"
          >
            <Typography variant="h3" gutterBottom className="drawer-title">
              Filters
            </Typography>
          </Stack>
          {/* Drawer head end */}
          {/* Drawer Content start */}
          <Stack
            className="p-3"
            style={{ height: "calc(100vh - 7rem)", overflowY: "scroll" }}
          >
            <form
              className="fillter_form2 CONTACT-LIST-AREA"
              style={{ height: "85vh", overflowY: "scroll" }}
            >
              <div className="custom_div">
                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="fromdate" className="form-label">
                    From
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id=""
                    aria-describedby="date"
                    value={fromdate}
                    onChange={(e) => setFromdate(e.target.value)}
                    max={defaultValue}
                  />
                </div>
                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="todate" className="form-label">
                    To
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id=""
                    aria-describedby="date"
                    value={todate}
                    onChange={(e) => setTodate(e.target.value)}
                    max={defaultValue}
                  />
                  {!isToDateValid() && (
                    <span
                      className="text-danger fw-bold"
                      style={{ fontSize: "10px" }}
                    >
                      To Date cannot be less than From Date*
                    </span>
                  )}
                </div>
                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="Select" className="form-label">
                    Status
                  </label>
                  <select
                    className="form-select fs-13"
                    aria-label="Default select example"
                    onChange={(e) => setstatus(e.target.value)}
                  >
                    <option value="">Select Status</option>
                    <option value="Pending">Pending</option>
                    <option value="Completed">Completed</option>
                    <option value="All">ALL</option>
                  </select>
                </div>
              </div>
            </form>
          </Stack>
          {/* Drawer Content end */}
          {/* Drawer footer start */}
          <Stack
            className="p-2"
            sx={{
              position: "absolute",
              bottom: "0",
              background: "#f9f9f9",
              width: "100%",
              boxShadow:
                "rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px",
            }}
            direction="row"
            justifyContent="space-between"
            alignContent="center"
          >
            <Button
              variant="contained"
              className="me-2 w-100"
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              color="error"
              disableElevation
              onClick={() => {
                setshowfilter(false);
              }}
            >
              Close
            </Button>
            <Button
              className="w-100"
              variant="contained"
              disableElevation
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              id="session_filter_Submit"
              onClick={() => {
                if (isToDateValid()) {
                  if (loggedInAgent.role == "Supervisor") {
                    SupervisorListCampaign();
                  } else {
                    AgentListCampaign();
                  }
                  setPage(1);
                  setshowfilter(false);
                }
              }}
            >
              Submit
            </Button>
          </Stack>
          {/* Drawer footer end */}
        </Box>
      </Drawer>
      {/* Filters Drawer end  */}
      {/* UploadDialogBox start here  */}
      {UploadDialogBox && (
        <Dialog
          open={UploadDialogBox}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
          fullWidth
          maxWidth="md"
        >
          {/* DialogTitle */}
          <DialogTitle
            variant="subtitle2"
            sx={{
              fontSize: "16px",
              fontWeight: 600,
              color: "#0b3363",
              boxShadow:
                "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
            }}
          >
            Upload File
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-slide-description"
              className="mt-3"
            >
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  {/* Choose file btn  */}
                  <Button
                    className="w-100"
                    disableElevation
                    variant="contained"
                    id="file-btn"
                    size="small"
                    endIcon={<MdDriveFolderUpload />}
                    onClick={() => {
                      UploadhandleClick();
                    }}
                    sx={{
                      textTransform: "Capitalize",
                      height: "40px",
                    }}
                  >
                    Choose file
                    <input
                      type="file"
                      ref={hiddenFileInput}
                      onChange={(event) => {
                        handleConfirmUploadPreview(event);
                      }}
                      style={{ display: "none" }}
                    />
                  </Button>
                  {/* Sample Sheet  */}
                  <DialogContentText
                    id="alert-dialog-slide-description"
                    className="mt-2"
                  >
                    <Stack
                      spacing={0.5}
                      sx={{ height: "40px", width: "450px" }}
                    >
                      <label
                        htmlFor="formFileSm"
                        className="form-label col-form-label-sm mb-3"
                        color="primary"
                      >
                        <div
                          style={{ fontSize: "12px" }}
                          className=" text-primary mb-2"
                        >
                          {selectedfile ? selectedfile.name : ""}
                        </div>

                        <p>
                          Please Download Sample Sheet{" "}
                          <a
                            href={
                              excelDownloadUrl + "/uploads/campaignexcel.xlsx"
                            }
                          >
                            Link
                          </a>{" "}
                          Here
                        </p>
                      </label>
                    </Stack>
                  </DialogContentText>
                </Grid>
                <Grid item xs={6}>
                  {/* Select Agent  */}
                  <Box className="w-100">
                    <FormControl size="small" className="fs-13 w-100">
                      <InputLabel id="demo-multiple-name-label">
                        Select Agent
                      </InputLabel>
                      <Select
                        labelId="demo-multiple-name-label"
                        id="demo-multiple-name"
                        multiple
                        value={selectedAgents}
                        onChange={handleChangeAgent}
                        input={<OutlinedInput label="Select Agent" />}
                        size="small"
                      >
                        {props.DropDownAgentList.length > 0 ? (
                          props.DropDownAgentList.map((Agent) => (
                            <MenuItem value={Agent.id} key={Agent.id}>
                              {Agent.username}
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem>{"No Data"}</MenuItem>
                        )}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleClose}
              variant="outlined"
              color="error"
              size="small"
              sx={{ textTransform: "capitalize !important" }}
            >
              Close
            </Button>
            {spinner ? (
              <span
                className="spinner-border spinner-border-sm text-primary"
                role="status"
                aria-hidden="true"
                style={{
                  flexDirection: "column",
                  marginTop: "20%",
                  display: "flex",
                  position: "absolute",
                  left: "45%",
                  bottom: "30%",
                }}
              ></span>
            ) : (
              <Button
                variant="contained"
                onClick={() => {
                  if (selectedfile) {
                    SaleshandleChangeFile(selectedfile);
                  }
                }}
                disabled={UploadButton}
                disableElevation
                size="small"
                sx={{ textTransform: "capitalize" }}
              >
                Upload
              </Button>
            )}
          </DialogActions>
        </Dialog>
      )}
      {/* UploadDialogBox end here  */}
      {/* transfer call start here  */}
      {openDialog && (
        <Dialog
          open={openDialog}
          keepMounted
          onClose={handleCloseDialogBox}
          aria-describedby="alert-dialog-slide-description"
          fullWidth
          maxWidth="md"
        >
          <DialogTitle
            variant="subtitle2"
            sx={{
              fontSize: "16px",
              fontWeight: 600,
              color: "#0b3363",
              boxShadow:
                "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
            }}
          >
            Transfer Call
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <Box className="mt-3">
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <label className="form-label">Date </label>
                    <input
                      type="Date"
                      max={defaultValue}
                      className="form-control"
                      onChange={(e) => {
                        setgetTransferDate(e.target.value);
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <label className="form-label">Source Agent </label>
                    <select
                      className="form-select"
                      onChange={(e) => {
                        setsourceAgents(e.target.value);
                      }}
                      defaultValue=""
                    >
                      <option value="" disabled>
                        Select Agent
                      </option>
                      {props.DropDownAgentList.length > 0 ? (
                        props.DropDownAgentList.map((Agent) => (
                          <option value={Agent.id} key={Agent.id}>
                            {Agent.username}
                          </option>
                        ))
                      ) : (
                        <option>{"No Data"}</option>
                      )}
                    </select>
                  </Grid>
                  <Grid item xs={6}>
                    <label className="form-label" for="cars">
                      Destination Agent{" "}
                    </label>
                    <select
                      className="form-select"
                      onChange={(e) => {
                        setDestinationAgents(e.target.value);
                      }}
                      defaultValue=""
                    >
                      <option value="" disabled>
                        Select Agent
                      </option>
                      {props.DropDownAgentList.length > 0 ? (
                        props.DropDownAgentList.map((Agent) => (
                          <option value={Agent.id} key={Agent.id}>
                            {Agent.username}
                          </option>
                        ))
                      ) : (
                        <option>{"No Data"}</option>
                      )}
                    </select>
                  </Grid>
                  <Grid item xs={6}>
                    <label className="form-label">Number </label>
                    <select
                      onChange={handleChangeCount}
                      className="form-select"
                    >
                      {Array.from({ length: totalcalls }, (_, index) => (
                        <option value={index + 1} key={index}>
                          {index + 1}
                        </option>
                      ))}
                    </select>
                  </Grid>
                </Grid>
              </Box>
            </DialogContentText>
          </DialogContent>

          <DialogActions>
            <Button
              onClick={handleCloseDialogBox}
              variant="outlined"
              color="error"
              size="small"
              sx={{ textTransform: "capitalize" }}
            >
              Close
            </Button>
            <Button
              variant="contained"
              onClick={transfer}
              disableElevation
              size="small"
              sx={{ textTransform: "capitalize !important" }}
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {opensuccessmodal && (
        <Dialog
          open={opensuccessmodal}
          keepMounted
          onClose={handleCloseDialogBoxresponse}
          aria-describedby="alert-dialog-slide-description"
          fullWidth
          maxWidth="sm"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <Box className="mt-3">
                <div>SuccessCount: {opensuccessmodalresponse.successCount}</div>
                <div>Message: {opensuccessmodalresponse.message}</div>
                <div>ErrorCount: {opensuccessmodalresponse.errorCount}</div>
              </Box>
            </DialogContentText>
          </DialogContent>

          <DialogActions>
            <Button
              onClick={handleCloseDialogBoxresponse}
              variant="outlined"
              color="error"
              size="small"
              sx={{ textTransform: "capitalize" }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {/* transfer call end here  */}
    </StyledPaper>
    // campaign start end
  );
};

export default connect(mapStateToProps, {
  setDialedNumberInc,
  getAvailableAgentList,
})(Campaign);
